import Vue from 'vue'
import store from '@/store/store.js'
import utils from '@/utils/index.js'

export function setCookie(name, value) {
    Vue.$cookies.set(name, value, -1)
}

export function getCookie(name) {
    let cookieName = `${name}=`
    let cookieArray = document.cookie.split(';')
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i].trim()
        if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length)
        }
    }
    return null
}

export const STEAMF_GAMEBOX_UUID = 'steamf-uuid'
export const STEAMF_GAMEBOX_TOKEN = 'steamf-gamebox-token'
export const STEAMF_GAMEBOX_CLIENT_VER = 'steamf-gamebox-client_ver'
export const STEAMF_GAMEBOX_CHANNEL = 'steamf-gamebox-channel'
export const STEAMF_GAMEBOX_YGX = 'steamf-gamebox-ygx'
export const STEAMF_GAMEBOX_STEAMID = 'steamf-gamebox-steamid'
export const STEAMF_GAMEBOX_LOGIN_POLICY = 'steamf-gamebox-login-policy'

/**
 * 登录协议版本号，协议更新后  在登录弹窗里做一些操作
 */
export function getLoginPolicyVersion() {
    return getCookie(STEAMF_GAMEBOX_LOGIN_POLICY)
}

export function setLoginPolicyVersion(v) {
    v && Vue.$cookies.set(STEAMF_GAMEBOX_LOGIN_POLICY, v, -1)
}

// 设置游戏盒子uuid，默认过期时间1天
export function checkUuid() {
    return Vue.$cookies.get(STEAMF_GAMEBOX_UUID)
}

// 获取steamid
export function getSteamId() {
    return Vue.$cookies.get(STEAMF_GAMEBOX_STEAMID)
}

// 移除steamid
export function removeSteamId() {
    Vue.$cookies.remove(STEAMF_GAMEBOX_STEAMID, '', 'steamf.cn')
    Vue.$cookies.remove(STEAMF_GAMEBOX_STEAMID)
}

// 保存steamid
export function setSteamId(id) {
    id && Vue.$cookies.set(STEAMF_GAMEBOX_STEAMID, id)
}

// 将token存入缓存
export function setTokenToCookies(token) {
    token && Vue.$cookies.set(STEAMF_GAMEBOX_TOKEN, token, 60 * 60 * 24 * 7)
}

export function getCookieToken() {
    return getCookie(STEAMF_GAMEBOX_TOKEN)
}

export function removeCookieToken() {
    Vue.$cookies.remove(STEAMF_GAMEBOX_TOKEN, '', 'steamf.cn')
    Vue.$cookies.remove(STEAMF_GAMEBOX_TOKEN)
}

export function canPlayGame(that, payload) {
    // 实名信息相关
    const { authInfo, authConfig } = store.state
    let status = authInfo.verification
    let isAdult = authInfo.isAdult
    const authConfigValue = authConfig.value
    if (authConfigValue == 1) {
        // 不实名
        return true
    } else if (authConfigValue == 2) {
        // 半强制实名 只弹框一次
        if (status == 1 && isAdult == 1) {
            // 已经实名认证过并且已成年
            return true
        } else {
            if (Vue.$cookies.get(store.state.userInfo.mobile)) {
                // 已经弹出认证弹框
                return true
            } else {
                that.$Auth.show(payload)
                return false
            }
        }
    } else if (authConfigValue == 3) {
        // 强制实名
        if (status == 1 && isAdult == 1) {
            //已实名认证并且已成年
            return true
        } else if (status == 1 && isAdult == 0) {
            // 已实名认证，未成年
            that.$Toast.show('实名认证信息显示未成年，暂不可游玩')
            return false
        } else if (status == 2) {
            // 实名认证中
            that.$Toast.show('实名认证信息中，待认证成功再开始游戏')
            if (getCookieToken()) {
                store.dispatch('userAuthInfoAction')
            }
            return false
        } else if (status == 0) {
            // 未实名认证 弹出实名认证弹框
            that.$Auth.show(payload)
            return false
        }
    }
}

// 判断跳转链接类型
// 返回值 0-->链接地址是空的 1-->相对路径（游戏盒子页面相对路径） 2-->http或者https路径  3-->cgm协议
export function judgeLinkType(link) {
    let formatLink = String(link)
    if (formatLink) {
        if (formatLink.startsWith('cgm://')) {
            // cgm协议类型
            return 3
        } else if (formatLink.startsWith('http')) {
            // http或者https路径
            return 2
        } else {
            return 1
        }
    } else {
        return 0
    }
}

function appendParametersToUrl(url, params) {
    // 必须是对象，如果不是返回原始url
    if (!utils.isObject(params)) {
        return url
    }

    // 检查 URL 是否已经含有查询参数
    var hasQuery = url.indexOf('?')

    // 构建参数字符串
    var paramString = ''
    for (var key in params) {
        // 如果是虚呗链接，剔除云更新公共参数userId， 'list.xubei.com'
        if (params.hasOwnProperty(key) && params[key]) {
            if (key == 'userId' && url.indexOf('list.xubei.com') > -1) {
            } else {
                paramString += '&' + key + '=' + encodeURIComponent(params[key])
            }
        }
    }

    // 去除第一个参数前的 "&" 符号
    paramString = paramString.slice(1)

    // 拼接参数到原始 URL
    if (hasQuery > -1) {
        // 原始链接已经带参数
        url += '&' + paramString
    } else {
        // 原始链接没有参数
        url += '?' + paramString
    }

    return url
}
